import { render, staticRenderFns } from "./TrustCenter.vue?vue&type=template&id=c6ecc460&scoped=true"
import script from "./TrustCenter.vue?vue&type=script&lang=js"
export * from "./TrustCenter.vue?vue&type=script&lang=js"
import style0 from "./TrustCenter.vue?vue&type=style&index=0&id=c6ecc460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ecc460",
  null
  
)

export default component.exports